module.exports = __webpack_public_path__ + "img/gf.43df4ad6.jpg";